<template>
  <div class="page">
    <a-row style="margin-bottom: 8px;">
      <a-form layout="inline" :form="form" @submit="handleSearch">
        <a-form-item :label="`关键字`">
          <a-input :span="10" v-decorator="[`kw`]" placeholder="文档模板名称"/>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">搜索</a-button>
          <a-button :style="{ marginLeft: '8px' }" @click="clearSearchForm">清空</a-button>
        </a-form-item>
        <a-form-item style="margin-left: 16px;">
          <a-button type="primary" @click="addDocTpl">添加文档模板</a-button>
        </a-form-item>
      </a-form>
    </a-row>
    <a-table :columns="table.header" :data-source="data"  :loading="table.loading" rowKey="id" :scroll="{y: table.scrollHeight}">
      <span slot="documentTemplate" slot-scope="item">{{item.documentTemplate=== 1?"文档":"模板"}}</span>
      <span slot="type" slot-scope="item">{{typeName(item.type)}}</span>
      <span slot="ownerSigned" slot-scope="item">{{item.documentTemplate=== 1?"是":"否"}}</span>
      <span slot="propertySigned" slot-scope="item">{{item.documentTemplate=== 1?"是":"否"}}</span>
      <div slot="enable" slot-scope="item">
        <a-switch v-model="item.enable" checked-children="启用" un-checked-children="禁用"  @change="switchEnable(item)" />
      </div>
      <div slot="ops" slot-scope="item">
        <a-button class="ops-button" type="primary" @click="editRow(item)">编辑</a-button>
        <a-button class="ops-button" @click="deleteRow(item)">删除</a-button>
      </div>
    </a-table>
    <!--添加文档模板-->
    <a-modal
        title="添加文档模板"
        width="60vw"
        :mask-closable="false"
        :ok-text="`确定`"
        :cancel-text="`取消`"
        :visible="modal.addDocTpl.show"
        :confirm-loading="modal.addDocTpl.confirmLoading"
        :dialog-style="{minWidth: '700px',maxWidth: '900px',top: '30%',marginTop: '-100px'}"
        @ok="addConfirm"
        @cancel="addCancel">
      <a-form :form="modal.addDocTpl.form" :label-col="{span:'6'}" :wrapper-col="{span: 14}">
        <a-row>
          <a-col :span="10">
            <a-form-item :label="`模板名称`">
              <a-input v-decorator="[`templateName`,{rules: [{required: true,message: '请输入模板名称'}]}]" placeholder="模板名称"/>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`文档模板`">
              <a-select :default-value="1" v-model="modal.addDocTpl.model.documentTemplate" placeholder="选择文档模板">
                <a-select-option :value="1">模板</a-select-option>
                <a-select-option :value="2">文档</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`文件类型`">
              <a-select :default-value="1" v-model="modal.addDocTpl.model.type" placeholder="选择文件类型">
                <a-select-option :value="1">导入模板</a-select-option>
                <a-select-option :value="2">其他模板</a-select-option>
                <a-select-option :value="3">入伙文档</a-select-option>
                <a-select-option :value="4">收房文档</a-select-option>
                <a-select-option :value="5">装修文档</a-select-option>
                <a-select-option :value="6">保修文档</a-select-option>
                <a-select-option :value="7">设备文档</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`上传文档模板`">
                <a-upload
                    name="file"
                    :headers="headers"
                    :fileList="this.downloadFiles"
                    :customRequest="downloadFilesCustomRequest"
                    :beforeUpload="beforeUpload"
                    :multiple="false"
                    :remove="handleDownloadFileRemove"
                    :disabled="this.isLoading"
                    :showUploadList="true">
                  <a-button> <a-icon type="upload" /> 上传文档模板 </a-button>
                </a-upload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="`业主是否签字`" >
              <a-radio-group v-decorator="['ownerSigned']">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`物业是否签字`">
              <a-radio-group v-decorator="['propertySigned']">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="排序">
              <a-input-number v-model="modal.addDocTpl.model.sort" :min="0"/>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="备注">
              <a-textarea v-model="modal.addDocTpl.model.remarks" placeholder="备注信息"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--编辑文档模板-->
    <a-modal
        title="编辑文档模板"
        width="60vw"
        :mask-closable="false"
        :ok-text="`确定`"
        :cancel-text="`取消`"
        :visible="modal.editDocTpl.show"
        :confirm-loading="modal.editDocTpl.confirmLoading"
        :dialog-style="{minWidth: '700px',maxWidth: '900px',top: '30%',marginTop: '-100px'}"
        @ok="editConfirm"
        @cancel="editCancel">
      <a-form :form="modal.editDocTpl.form" :label-col="{span:'6'}" :wrapper-col="{span: 14}">
        <a-row>
          <a-col :span="10">
            <a-form-item :label="`模板名称`">
              <a-input v-decorator="[`templateName`,{rules: [{required: true,message: '请输入模板名称'}]}]" placeholder="模板名称"/>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`文档模板`">
              <a-select v-model="modal.editDocTpl.model.documentTemplate" placeholder="选择文档模板">
                <a-select-option :value="1">模板</a-select-option>
                <a-select-option :value="2">文档</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`文件类型`">
              <a-select v-model="modal.editDocTpl.model.type" placeholder="选择文件类型">
                <a-select-option :value="1">导入模板</a-select-option>
                <a-select-option :value="2">其他模板</a-select-option>
                <a-select-option :value="3">入伙文档</a-select-option>
                <a-select-option :value="4">收房文档</a-select-option>
                <a-select-option :value="5">装修文档</a-select-option>
                <a-select-option :value="6">保修文档</a-select-option>
                <a-select-option :value="7">设备文档</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`上传文档模板`">
              <a-upload
                  name="file"
                  :headers="headers"
                  :fileList="this.downloadFiles"
                  :customRequest="downloadFilesCustomRequest"
                  :beforeUpload="beforeUpload"
                  :multiple="false"
                  :remove="handleDownloadFileRemove"
                  :disabled="this.isLoading"
                  :showUploadList="true">
                <a-button> <a-icon type="upload" /> 上传文档模板 </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="`业主是否签字`" >
              <a-radio-group  v-decorator="['ownerSigned']">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item :label="`物业是否签字`">
              <a-radio-group v-decorator="['propertySigned']">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="排序">
              <a-input-number v-model="modal.editDocTpl.model.sort" :min="0"/>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="备注">
              <a-textarea v-decorator="['remarks']"  placeholder="备注信息"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import DocTplService from "@/service/DocTplService";

export default {
  name: "DocTpl",
  data(){
    return {
      pagination:{
        current: 1,
        total: 0,
        pageSize: 10
      },
      kw: null,
      downloadFiles:[],
      isLoading: false,
      table: {
        loading: true,
        header: [
        {
          title: '文档模板名称',
          width: 200,
          dataIndex: 'templateName'
        },
        {
          title: '文档模板',
          width: 150,
          scopedSlots: {customRender: 'documentTemplate'}
        },
        {
          title: '类型',
          width: 150,
          scopedSlots: {customRender: 'type'}
        },
        {
          title: '路径',
          width: 300,
          dataIndex: 'templatePath'
        },
        {
          title: '业主是否签字',
          scopedSlots: {customRender: 'ownerSigned'}
        },
        {
          title: '物业是否签字',
          scopedSlots: {customRender: 'propertySigned'}
        },
        {
          title: '启用',
          scopedSlots: {customRender: 'enable'}
        },
        {
          title: '操作',
          scopedSlots: {customRender: 'ops'}
        },
        ],
        locale: {
          emptyText: '暂无数据'
        },
        scrollHeight: 0
      },
      form: this.$form.createForm(this,{name: 'searchForm'}),
      expand: false,
      data:[],
      modal: {
        addDocTpl: {
          show: false,
          confirmLoading: false,
          form: this.$form.createForm(this,{name: 'createForm'}),
          model: {
            documentTemplate: 1,
            type: 1,
            enable: false,
            templatePath: "https://www.163.com/",
            sort: 0
          }
        },
        editDocTpl: {
          id: null,
          show: false,
          confirmLoading: false,
          form: this.$form.createForm(this,{name: 'editForm'}),
          model: {
            documentTemplate: 1,
            type: 1,
            enable: false,
            templatePath: "https://www.baidu.com/",
            sort: 0
          }
        }
      },
      headers: {
        'content-type': 'multipart/form-data',
        'gateway-from': 'root-admin-api-gateway'
      }
    }
  },
  methods: {
    clearSearchForm(){
      this.form.resetFields();
    },
    handleSearch(e){
      e.preventDefault();
      let _this = this;
      this.form.validateFields((err,values)=>{
        if (!err){
          _this.pagination.current = 1;
          _this.pagination.total = 0;
          _this.kw = values.kw;
          _this.reloadData();
        }
      });
    },
    addDocTpl(){
      this.modal.addDocTpl.show = true;
    },
    addConfirm(e){
      e.preventDefault();
      let _this = this;
      this.modal.addDocTpl.form.validateFields((err,values)=>{
        if (!err){
          values.enable = this.modal.addDocTpl.model.enable;
          values.documentTemplate = this.modal.addDocTpl.model.documentTemplate;
          values.type = this.modal.addDocTpl.model.type;
          values.templatePath = JSON.parse(this.downloadFiles[0].linkProps).download;
          console.log('验证通过',values);

          this.$confirm({
            title: '确定提交以上信息吗？',
            content: '请仔细核对信息后再提交',
            onOk(){
              _this.modal.addDocTpl.confirmLoading = true;
              DocTplService.createDocTpl(values).then(data=>{
                _this.modal.addDocTpl.confirmLoading = false;
                _this.modal.addDocTpl.show = false;
                _this.modal.addDocTpl.form.resetFields();
                _this.downloadFiles = [];
                _this.reloadData();
              }).catch(e=>{
                _this.$message.error(e);
                _this.modal.addDocTpl.confirmLoading = false;
              })
            }
          })

        }
      })
    },
    addCancel(){
      this.modal.addDocTpl.form.resetFields();
      this.modal.addDocTpl.show = false;
      this.downloadFiles = [];
    },
    editRow(item){
      this.modal.editDocTpl.show = true;
      this.modal.editDocTpl.id = item.id;
      this.modal.editDocTpl.model.type = item.type;
      this.modal.editDocTpl.model.documentTemplate = item.documentTemplate;
      this.modal.editDocTpl.model.enable = item.enable;
      this.downloadFiles.push({
        uid: item.templatePath,
        name: item.templatePath,
        status: 'done',
        response: '{"status": "success"}',
        linkProps: '{"download":"'+(item.templatePath)+'"}',
        xhr: 'XMLHttpRequest{}'
      });
      this.$nextTick(()=>{
        this.modal.editDocTpl.form.setFieldsValue(item);
      });
    },
    editConfirm(e){
      e.preventDefault();
      let _this = this;
      this.modal.editDocTpl.form.validateFields((err,values)=>{
        if (!err){
          values.enable = this.modal.editDocTpl.model.enable;
          values.documentTemplate = this.modal.editDocTpl.model.documentTemplate;
          values.type = this.modal.editDocTpl.model.type;
          values.templatePath = JSON.parse(this.downloadFiles[0].linkProps).download;
          console.log('验证通过',values);
          this.$confirm({
            title: '确定提交以上信息吗？',
            content: '请仔细核对信息后再提交',
            onOk(){
              _this.modal.editDocTpl.confirmLoading = true;
              DocTplService.updateDocTpl(_this.modal.editDocTpl.id,values).then(data=>{
                _this.modal.editDocTpl.confirmLoading = false;
                _this.modal.editDocTpl.show = false;
                _this.modal.editDocTpl.form.resetFields();
                _this.downloadFiles = [];
                _this.reloadData();
              }).catch(e=>{
                _this.$message.error(e);
                _this.modal.editDocTpl.confirmLoading = false;
              })
            }
          })
        }
      })
    },
    editCancel(){
      this.modal.editDocTpl.form.resetFields();
      this.modal.editDocTpl.show = false;
      this.downloadFiles = [];
    },
    deleteRow(item){
      let _this = this;
      this.$confirm({
        title: '确定删除该文档模板吗？',
        content: '点击确认删除',
        onOk(){
          DocTplService.deleteDocTpl(item.id).then(data=>{
            console.log("删除成功");
            _this.refreshValueData();
          }).catch(e=>{
            console.log("e",e);
            _this.$message.error(e);
          })
        }
      })
    },
    reloadData(){
      DocTplService.getPageList(this.pagination.current,this.pagination.pageSize,this.kw).then((data)=>{
        this.table.loading = false;
        this.data = data.list;
      }).catch(e=>{
        this.table.loading = false;
        this.$message.error("数据获取失败");
      })
    },
    handleChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    typeName(index){
      return ["导入模板", "其他模板", "入伙文档", "收房文档", "装修文档","保修文档","设备文档"][index-1];
    },
    switchEnable(item){
      let _this = this;
      this.$confirm({
        title: "确定" + (item.enable?"启用":"禁用") + "该文档模板吗？",
        content: '点击确定生效',
        onOk(){
          DocTplService.switchDocTplEnable(item.id,item.enable).then(da=>{
            console.log("切换成功");
          }).catch(e=>{
            console.log("e",e);
            _this.$message.error(e);
            item.enable = !item.enable;
          })
        }
      });
    },
    handleDownloadFileRemove(file){
      const index = this.downloadFiles.indexOf(file)
      const newFileList = this.downloadFiles.slice()
      newFileList.splice(index, 1)
      this.downloadFiles = newFileList
    },
    downloadFilesCustomRequest(file){
      DocTplService.uploadFiles(file).then((data)=>{
        this.downloadFiles.push({
          uid: data.keyPath,
          name: data.name,
          status: 'done',
          response: '{"status": "success"}',
          linkProps: '{"download":"'+(data.url)+'"}',
          xhr: 'XMLHttpRequest{}'
        });
      }).catch(e=>{
        this.$message.error("文档模板上传失败");
      })
    },
    beforeUpload(file){

    }
  },
  mounted() {
    this.reloadData();
    this.table.scrollHeight = (document.documentElement.clientHeight || document.body.clientHeight) - 280
    console.log("sc",this.table.scrollHeight)
  }
}
</script>

<style scoped>

</style>
